import { BadgeColumn } from '@app/modules/table/classes/badge-column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { BadgeDisplay } from '@app/modules/table/interfaces/badge-display.interface';
import { Invoice } from '@models/settings/billing/invoice.model';

export class StatusColumn extends BadgeColumn<Invoice> {
    title = 'settings.invoice-table.statusColumn';
    property = 'status';
    sortable = false;
    type: CellDisplay = CellDisplay.badge;

    getBadgeDisplay(invoice: Invoice): BadgeDisplay | undefined {
        switch (invoice.status) {
            case 'paid':
                return {
                    type: 'success',
                    label: 'settings.invoice-table.paidStatusLabel',
                };
            case 'open':
                return {
                    type: 'warning',
                    label: 'settings.invoice-table.unpaidStatusLabel',
                };
            case 'draft':
                return {
                    type: 'default',
                    label: 'settings.invoice-table.upcomingStatusLabel',
                };
        }
    }
}
